export default {
      id: "minus-usage",
      viewBox: "0 0 13 2",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#minus",
      toString: function () {
        return this.url;
      }
    }